import OrderDirectionsEnum from "../Enums/OrderDirectionsEnum"
export class orderByHelper
{
	static newOrderByDirection(oldOrderById, newOrderbyId, oldDirection)
	{
		if(newOrderbyId!==oldOrderById) return OrderDirectionsEnum.Asc;

		return (
			oldDirection===OrderDirectionsEnum.Asc
				? OrderDirectionsEnum.Desc
				: OrderDirectionsEnum.Asc
		);
	}

	
	
}

export default orderByHelper;